import { Component, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { Id3StepperComponent } from '@id3/tools';
import { combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';
import { CovidTestUserFormComponent } from './components/forms/covid-test-user-form/covid-test-user-form.component';

import { GlobalSandbox } from './shared/sandbox/providers/global.sandbox';

@Component({
	selector: 'id3-bioseal-generation',
	templateUrl: 'bioseal-generation.component.html',

	styleUrls: ['./bioseal-generation.component.css'],
	providers: [GlobalSandbox]
})
export class BiosealGenerationComponent implements OnInit {
	@ViewChild(Id3StepperComponent) stepper: Id3StepperComponent;
	@ViewChild(CovidTestUserFormComponent) covidTest: CovidTestUserFormComponent;
	@Input()
	set startGeneration(value: boolean) {
		if (value) {
			this.globalSandbox.init();
		}
	}
	@Input()
	set primaryColor(value: string) {
		this.globalSandbox.setPrimaryColor(value);
	}

	@Input()
	set secondaryColor(value: string) {
		this.globalSandbox.setSecondaryColor(value);
	}
	@Input()
	set tertiaryColor(value: string) {
		this.globalSandbox.setTertiaryColor(value);
	}
	@Input()
	set language(value: string) {
		this.globalSandbox.setLanguage(value);
	}
	@Input()
	set faceUrl(value: string) {
		this.globalSandbox.setFaceUrl(value);
	}
	@Input()
	set biosealUrl(value: string) {
		this.globalSandbox.setBioSealUrl(value);
	}
	@Input()
	set authorization(value: string) {
		this.globalSandbox.setAuthorization(value);
	}
	@Input()
	set verificationUrl(value: string) {
		this.globalSandbox.setVerification(value);
	}
	@Input()
	set photoDisplay(value: boolean) {
		this.globalSandbox.setPhotoDisplay(value);
	}
	@Output() onAuthTimeOut: EventEmitter<boolean> = new EventEmitter<boolean>();
	constructor(public globalSandbox: GlobalSandbox) {
		globalSandbox.configurateLanguage();
	}
	next() {
		this.globalSandbox.manageStepperControls();
		this.globalSandbox.increment();
		if (this.stepper) {
			this.stepper.next();
		}
	}
	previous() {
		combineLatest([
			this.globalSandbox.isAccreditationUseCase(),
			this.globalSandbox.isEventForm()
		]).pipe(take(1)).subscribe(
			([useCase, form]) => {
				if ((!form || (form && !useCase)) && this.stepper) {
					this.stepper.previous();
				}
				this.globalSandbox.decrement();
			}
		)
	}
	ngOnInit(): void {
		let root = document.documentElement;
		combineLatest([
			this.globalSandbox.timeoutBioSeal,
			this.globalSandbox.timeoutFace
		]).subscribe(([timeOutBioSeal, timeoutFace]) => {
			return this.onAuthTimeOut.emit(timeOutBioSeal || timeoutFace);
		});
		this.globalSandbox.global.subscribe((item) => {
			root.style.setProperty('--primary-color', item.primaryColor);
			root.style.setProperty('--secondary-color', item.secondaryColor);
			root.style.setProperty('--tertiary-color', item.tertiaryColor);
		});
	}
}
